// start:ng42.barrel
export * from './title.component';
// end:ng42.barrel




// WEBPACK FOOTER //
// ./src/main/webapp/stay-mgmt/app/components/title/index.ts